import { useState } from 'react'
import React from 'react'
import { useSearchParams } from 'react-router-dom'

import { ParsedLatestFilingsData } from '../constants/types'

const FILTER_KEY = 'f'

function getDefaultFilterFromUrl(params: URLSearchParams): string | null {
  return params.get(FILTER_KEY) ?? null
}

function saveFilterToUrl(prev: URLSearchParams, filterId: string | null) {
  const newParams = new URLSearchParams(prev)
  if (filterId === null) {
    newParams.delete(FILTER_KEY)
  } else {
    newParams.set(FILTER_KEY, filterId)
  }
  return newParams
}

interface Props {
  data: ParsedLatestFilingsData | null
}

export function useTableFilter({ data }: Props) {
  const [searchParams, setSearchParams] = useSearchParams()

  const filterItems = React.useMemo(
    () => [
      { id: 'all', label: 'View all', value: null, forms: [] },
      ...(data?.formCategories.map((formCategory) => ({
        ...formCategory,
        value: formCategory.id,
        disabled: !data?.items.some((item) => formCategory.forms?.includes(item.form || '')),
      })) ?? []),
    ],
    [data]
  )

  const [currentCategory, setCurrentCategory] = useState<string | null>(getDefaultFilterFromUrl(searchParams))

  const filteredData = React.useMemo(() => {
    if (!currentCategory) return data?.items
    const category = data?.formCategories.find((category) => category.id === currentCategory)
    return data?.items.filter((x) => (!x.form ? true : category!.forms.includes(x.form))) ?? null
  }, [currentCategory, data])

  const setCategory = React.useCallback(
    (cat: string | null) => {
      setSearchParams((prev) => saveFilterToUrl(prev, cat))
      setCurrentCategory(cat)
    },
    [setSearchParams]
  )

  return { currentCategory, setCategory, data: filteredData, filterItems }
}
